var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "report-menu" }, [
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: { active: _vm.currentTab === _vm.ReportTabs.Sites },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams("report", _vm.ReportTabs.Sites)
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("language")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("adminReportsPage.menuCustomers")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: { active: _vm.currentTab === _vm.ReportTabs.AgentCount },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams("report", _vm.ReportTabs.AgentCount)
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("people")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("adminReportsPage.menuAgentCount")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: { active: _vm.currentTab === _vm.ReportTabs.Payments },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams("report", _vm.ReportTabs.Payments)
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("payments")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("adminReportsPage.menuPayments")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: { active: _vm.currentTab === _vm.ReportTabs.CustomerCandidate },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams(
              "report",
              _vm.ReportTabs.CustomerCandidate
            )
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("insights")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("adminReportsPage.menuLeadAnalysis")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: { active: _vm.currentTab === _vm.ReportTabs.Plan },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams("report", _vm.ReportTabs.Plan)
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("filter_none")]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("adminReportsPage.menuPlans")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "box yes-hover",
        class: { active: _vm.currentTab === _vm.ReportTabs.Balance },
        on: {
          click: function ($event) {
            return _vm.updateQueryParams("report", _vm.ReportTabs.Balance)
          },
        },
      },
      [
        _c("p", { staticClass: "label" }, [
          _c("i", { staticClass: "material-icons" }, [
            _vm._v("account_balance_wallet"),
          ]),
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("adminReportsPage.menuWallet")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "value" },
          [
            _vm.loading
              ? _c("BarSpinner", {
                  attrs: { className: "spinner", radius: 15 },
                })
              : _vm._e(),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }